module.exports = __webpack_public_path__ + "static/media/01F75D69-28B7-451B-8319-0A0D366E22DD.ec714e7a.JPG";